import { render, staticRenderFns } from "./ClientRequestCreateModal.vue?vue&type=template&id=4745b87b"
import script from "./ClientRequestCreateModal.vue?vue&type=script&lang=js"
export * from "./ClientRequestCreateModal.vue?vue&type=script&lang=js"
import style0 from "./ClientRequestCreateModal.vue?vue&type=style&index=0&id=4745b87b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports